<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Sim Card Types</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="()=>{selectedType=null; dialogSwitch = true}">Add
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Short Name</th>
                        <th>Vendor Name</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="type in types" v-if="types.length" :key="type.id" class="text-left">
                        <td>{{ type.short_name }}</td>
                        <td>{{ type.vendor_name }}</td>
                        <td>{{ type.description }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn class="text-warning" size="x-small"
                                       @click="editType(type)">Edit
                                </v-btn>
                                <v-btn class="text-error" size="x-small"
                                       @click="deleteType(type)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
    </v-container>

    <Create_Edit v-if="dialogSwitch"
                 v-model="dialogSwitch"
                 :type="selectedType"
                 @addType="addType"
                 @updateType="updateType"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Create_Edit from "@/components/dialogs/sim-cards/Type_Create_Edit.vue";

const types = ref([]);
const loading = ref(true);
const selectedType = ref(null);
const dialogSwitch = ref(false);
const {showSnackbar} = useSnackbarStore();

onMounted(() => {
    fetchTypes();
});

const fetchTypes = () => {
    send('get', `admin/sim-card-types`)
        .then((response) => {
            types.value = response.data.data;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Sim card types could not be loaded', 'error')
        })
}
const addType = (type) => {
    types.value.unshift(type);
}
const editType = (type) => {
    selectedType.value = type;
    dialogSwitch.value = true;
}
const updateType = (type) => {
    types.value.map((item, index) => {
        if (item.id === type.id) {
            types.value[index] = type;
        }
    });
}
const deleteType = (type) => {
    if (confirm(`Are you sure to delete "${type.title}" sim card type?`)) {
        send('delete', `admin/sim-card-types/${type.id}`)
            .then((response) => {
                if (response.data.success) {
                    types.value.map((item, index) => {
                        if (item.id === type.id) {
                            types.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${type.title}" sim card type could not be deleted`, 'error')
                }
            })
    }
}
</script>
